module.exports = __webpack_public_path__ + "static/media/s1.96ddbb20.png";